import React, { useState, useEffect } from 'react'
import { useDispatch, useStore } from 'react-redux'
import Icon from '@ant-design/icons'
import ds from '../../Services/DataServices'
import IntlMessages from '../../util/IntlMessages'
import {
  Table,
  Layout,
  Card,
  Col,
  Row,
  Button,
  Divider,
  Checkbox,
  InputNumber,
  Modal,
  Collapse,
  Panel
} from 'antd'
import AddProductTags from '../../components/AddProductTags'
import ProductTag from '../../assets/images/product-tags.png'
import { loadData } from '../../appRedux/actions/Setting'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { setCommonConfigs } from '../../appRedux/actions/CommonData'
import { PRODUCTTAGS } from '../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck
} from '../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
// import { REACT_APP_BUS_FIRST_NAME, REACT_APP_BUS_NAME } from '../../constants/StoreSetting'
import { env } from '../../env'

const { REACT_APP_BUS_FIRST_NAME, REACT_APP_BUS_NAME } = env

const ProductTags = () => {
  const Panel = Collapse.Panel
  const history = useHistory()
  const store = useStore()
  const dispatch = useDispatch()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [Loader, setLoader] = useState(true)
  const [tagsListData, settagsListData] = useState()
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getPagination, setPagination] = React.useState({
    current: 1,
    pageSize: 10
  })
  const [isLoading, setIsLoading] = React.useState(true)
  const [loadDataState, setloadDataState] = useState(false)

  React.useEffect(() => {
    handleChange()
    const unsub = store.subscribe(handleChange)
    dispatch(setCommonConfigs(PRODUCTTAGS))
    let body = { CurrentPageNo: getPagination.current }
    getProductTagsData(body)
    return () => {
      unsub()
    }
  }, [loadDataState])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  async function getProductTagsData (body) {
    setIsLoading(true)
    const getTypeData = ds.getProductTags(body, BEHAVIOUR_TYPE.GET)
    await getTypeData
      .then(response => {
        if (response.data.data != null) {
          let mapped = response.data.data.map(productTag => {
            return {
              key: productTag.productTagGuid,
              name: productTag.productTagName,
              tagID: productTag.productTagID,
              numofproducts: productTag.nbrOfProducts
            }
          })
          settagsListData(mapped)
          let paginationObj = {
            current: body.CurrentPageNo,
            pageSize: getPagination.pageSize,
            total:
              response.data.data.length > 0
                ? response.data.data[0].totalRecords
                : 0
          }
          setPagination(paginationObj)
          setIsLoading(false)
          if (loadDataState) {
            setloadDataState(false)
          }
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
      })
  }
  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  const columns = [
    {
      title: <IntlMessages id='products.productypes.name' />,
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: <IntlMessages id='products.productypes.noofproducts' />,
      dataIndex: 'numofproducts',
      key: 'numofproducts'
    },
    {
      title: <IntlMessages id='products.brands.viewproduct' />,
      key: 'viewproduct',
      render: (text, record) => {
        //const [form] = Form.useForm();
        const viewProduct = async tagid => {
          history.push(`/dashboard/products/main/listing/tagid/${record.tagID}`)
        }
        return (
          <div>
            <span>
              <a
                onClick={() => viewProduct(record.key)}
                className='gx-link'
              >
                View Product
              </a>
            </span>
          </div>
        )
      }
    },
    {
       title: <IntlMessages id="products.productypes.edit" />,
      key: 'edit',
      render: (text, record) => (
        <>
          <div>
            <AddProductTags
              behavior='3'
              recordId={record.key}
              valueText={record.name}
              tagID = {record.tagID}
            />
          </div>
        </>
      )
    },
    {
      title: <IntlMessages id="products.productypes.delete" />,
      key: 'delete',
      render: (text, record) => (
        <>
          <div>
            <AddProductTags
              behavior='2'
              recordId={record.key}
              valueText={record.name}
            />
          </div>
        </>

        /*        <span>
              <span className="gx-link"><IntlMessages id="products.productypes.delete" /></span>
          </span>*/
      )
    }
  ]

  const handleChange = () => {
    if (store.getState().settings.loadData != loadDataState) {
      setloadDataState(store.getState().settings.loadData)
      dispatch(loadData(false))
    }
  }
  const handleTableChange = (pagination, filters, sorter) => {
    let body = { CurrentPageNo: pagination.current }
    getProductTagsData(body)
  }

  return (
    <>
      <div className='Content-wrapper Producttags-pg'>
        
        
      <Row className="align-items-center justify-content-center mb-3 Product-header">
          <Col lg={12} md={12} sm={24} xs={24}>
            <h1 className="mb-0">
                <IntlMessages id='products.productTags.productTags' />
              </h1>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
            <div className="pg-header-btn">
                <AddProductTags behavior='1' type='edit' />
              </div>
            </Col>
          </Row>
        
        
        <Card className='gx-card' title=''>
          <Collapse>
            <Panel
              className='custom-promolist-help'
              header={
                <IntlMessages id='products.productypes.needhelpheading' />
              }
              showArrow={false}
            >
              <Row>
                <div className='billing-main'>
                  <Col className='custom-promolist-helpdesc' md={12}>
                    <p>
                      <IntlMessages id='products.productTags.produdctTageNeedHelpDescription1' />
                    </p>
                    <p>
                      <IntlMessages
                        id='products.productTags.produdctTageNeedHelpDescription2'
                        values={{
                          strong: chunks => <strong>{chunks}</strong>,
                          // bus_name: REACT_APP_BUS_NAME,
                          bus_name_first: REACT_APP_BUS_FIRST_NAME
                        }}
                      />
                    </p>
                  </Col>

                  <Col md={12}>
                    <img src={ProductTag} alt='' />
                  </Col>
                </div>
              </Row>
            </Panel>
          </Collapse>
        </Card>

        <div className='tab-body-parent'>
          <Card title=''>
            {isLoading ? (
              <Skeleton count={7} height={35} />
            ) : (
              <Table
                className='gx-table-responsive'
                columns={columns}
                dataSource={tagsListData}
                pagination={getPagination}
                onChange={handleTableChange}
              />
            )}
          </Card>
        </div>
      </div>
    </>
  )
}
export default ProductTags
